export default {"src":"/_next/static/media/signOut.ca30acb0.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};